module.exports = __webpack_public_path__ + "img/nolan-rest-api.b6f87f02.svg";